import * as React from "react";

import type { DesignaliProps } from "../../types";

export const SquarePower = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M12 7v4" />
        <path d="M7.998 9.003a5 5 0 1 0 8-.005" />
        <rect x="3" y="3" width="18" height="18" rx="2" />
      </svg>
    );
  },
);

export default SquarePower;
